import * as React from "react";

function PrivacyPolicy() {
  return (
    <div>
      <section className="content">
        {/* <h2>OUR DATA PROTECTION POLICY</h2> */}
        {/* <hr /> */}
        <h3>Privacy Policy</h3>
        <p>
          We take the protection of your personal data very seriously. We treat
          your personal data confidentially and in accordance with the legal
          data protection regulations, as well as this data privacy statement.
          Personal data is only collected and processed on this website to the
          extent that is necessary. The following statement gives you an
          overview of how we ensure this protection and what type of data is
          collected for what purpose.
        </p>
        <hr />
        <h3>Name and address of the controller</h3>
        <p>The controller as per the data protection legislation is:</p>
        <p>
          Arbonia AG <br /> Amriswilerstrasse 50 <br /> 9320 Arbon <br />{" "}
          Switzerland
        </p>
        <p>
          T +41 71 447 41 41 <br /> holding@arbonia.com
        </p>
        <hr />
        <h3>1. Your rights</h3>
        <p>
          When you use this website, various personal data is collected.
          Personal data is data which can be used to identify you personally.{" "}
        </p>
        <p>
          At any time, you have the right, within the scope of the applicable
          legal provisions, to receive information about your stored personal
          data, its origin, as well as the recipients and purpose of data
          processing. If legal pre-requisites exist, you have the right to the
          correction or deletion of your personal data, the restriction of its
          processing, the right of objection against the processing as well as
          data transferability.
        </p>
        <p>
          If you have given your consent to the processing of your personal data
          by us, you have the right to revoke the consent at any time. The
          lawfulness of the processing of your personal data before the
          revocation is not affected by the revocation. The further processing
          of data on another legal basis, such as the fulfillment of legal
          obligations, remains unaffected by this.
        </p>
        <p>
          If you believe that the processing of your personal data by us
          violates the applicable data protection law, you have the right to
          complain to the responsible authorities.{" "}
        </p>
        <hr />
        <h3>2. The compilation and processing of personal data</h3>
        <h5>a) When visiting our website</h5>
        <p>
          When you visit our website, we process data which your browser
          automatically sends to us. The data comprises your IP address, the
          time of the server request, the browser type and version, operating
          system used, referrer URL, host name of the accessing computer. We
          only process personal data about the use of our website if this is
          necessary to allow the user to use the service.
        </p>
        <p>
          The collection and processing of this data is done for internal
          statistical purposes. The basis for the processing of data is for the
          execution of a contract or pre-contractual measures. The further basis
          for the data processing is our justified interest to process the data,
          to ensure the stability and security of the website.
        </p>
        <p>
          We sometimes also use cookies for this. Cookies are small text files
          which are stored on your computer and which your browser saves. They
          are used to make our offer more user-friendly, effective and secure.
          Most of the cookies used by us are so-called "session cookies". They
          will be automatically deleted at the end of your session. Cookies do
          not harm your computer and do not contain viruses. You have the option
          to deactivate this function in your browser or to adjust the settings,
          so that you can determine in individual cases whether a cookie should
          be accepted or not. In this case the usability of our website may,
          however, be restricted. Cookies which are necessary to execute the
          electronic communication procedure or to provide certain functions
          (e.g. the shopping basket function) are stored based on our justified
          interest in saving cookies to ensure we provide our services in an
          optimised and technically error-free manner.{" "}
        </p>

        <h5>b) When using a contact form</h5>
        <p>
          If you send requests to us, your details in the request form as well
          as any contact data you provide, will be saved by us for the purpose
          of handling your request and for any follow-up questions. We do not
          pass on the data to third parties without your consent.
        </p>
        <p>
          The processing of your data is done on the basis of your consent. You
          can revoke this consent at any time. To do so it is sufficient to send
          an informal message to us by e-mail. The lawfulness of data processing
          actions performed before the revocation, remain unaffected by the
          revocation.
        </p>
        <p>
          Your data remains with us until you request that we delete it, you
          revoke your consent to save the data or if the purpose for saving the
          data no longer applies (e.g. after your request has been processed).
          Legal storage periods remain unaffected by this.
        </p>
        <h5>c) Data processing in application procedures</h5>
        <p>
          We collect and process the personal data of applicants for the purpose
          of handling the application procedure. If an employment contract is
          concluded with an applicant, the transferred data is saved for the
          purpose of handling the employment relationship, taking legal
          provisions into account.{" "}
        </p>
        <p>
          If an employment contract is not concluded with the applicant, the
          application documents are deleted six months after the notification of
          rejection, provided the deletion does not conflict with any other
          justified interests of the controller.{" "}
        </p>
        <p>
          The processing of personal data for the afore-mentioned purposes is
          done on the basis of consent, or based on a justified interest which
          conflicts with the deletion.
        </p>
        <p>
          We can cooperate with other Arbonia Group companies and other
          third-party data processors (e.g. IT service providers). Any transfer
          of personal data is done in accordance with the applicable data
          protection laws, and suitable contractual, technical and
          organisational measures exist.
        </p>
        <p>
          <b>Notes about rexx</b>
          <br />
          We use the services of rexx systems GmbH, Headquarters, Süderstrasse
          75–79, 20097 Hamburg, Germany ("rexx"). The Swiss subsidiary, rexx
          systems Schweiz AG, is registered at Sparrenbergstrasse 5, 8103
          Zurich. After entering and transferring personal data in the
          application procedure, your data may, via a direct encrypted transfer,
          reach the server of rexx which only saves the data, once encrypted, on
          its server at the computer centre of Host Europe GmbH (Cologne). If
          this is the case, all data is encrypted using SSL. If you login with
          the user data provided after registration, SSL encryption is also used
          for this.
        </p>
        <p>
          The transfer of personal data is done in accordance with the
          applicable data protection laws, and suitable contractual, technical
          and organisational measures exist. Both the controller and the
          provider implement technical and organisational safety measures to
          protect the collected data from accidental or wilful manipulation,
          loss, destruction or access by unauthorised people. Our safety
          measures are continually improved according to the latest
          technological developments.
        </p>
        <h5>d) Data processing for the sending of newsletters and mailings</h5>
        <p>
          If you subscribe to one of the newsletters or mailings offered on the
          website, the data provided when subscribing for the newsletter or
          mailing is used to send the newsletter, provided you have not agreed
          to further use. You agree that we are also allowed to transfer this
          personal data to other Arbonia Group companies, and also that other
          Arbonia Group companies can use this data for the same purpose, and
          send you newsletters about the whole range of offers of the Arbonia
          Group companies. We do not pass on your personal data to third parties
          outside of the Arbonia Group companies.
        </p>
        <p>
          If you subscribe to the e-mail newsletter, for which it is necessary
          to enter personal data, you will receive a confirmation e-mail sent to
          the e-mail address you have provided. Only after clicking on the link
          in this e-mail is the registration process completed. The processing
          is done exclusively on the basis of your consent. You can revoke the
          consent you have issued to save the data, the e-mail address and its
          use to send the newsletter at any time via the unsubscribe option in
          the newsletter. The lawfulness of the data processing actions already
          performed before the revocation, remain unaffected by the revocation.
        </p>
        <p>
          Data you have provided when registering for the newsletter is saved by
          us until you are removed from the newsletter distribution list and
          have unsubscribed from the newsletter. Data which has been saved by us
          for another purpose or based on another consent (e.g. e-mail addresses
          for a different newsletter, or for other functions on the website)
          remain unaffected by this.
        </p>
        <p>
          We can cooperate with other Arbonia Group companies and other
          third-party data processors (e.g. IT service providers). Any transfer
          of personal data is done in accordance with the applicable data
          protection laws, and suitable contractual, technical and
          organisational measures exist.
        </p>
        <hr />
        <h3>
          3. Transfer of personal data and data processing by third parties
        </h3>
        <p>
          In general, we only use personal data for internal business purposes.
          For this purpose we are allowed to transfer personal data to other
          Arbonia Group companies, and other Arbonia Group companies can also
          use this data for the same purpose. We do not pass on your personal
          data outside of the Arbonia Group companies, unless this is necessary
          for the execution of the contract, is legally permissible or you have
          consented to it.{" "}
        </p>
        <p>
          We can, however, conclude agreements with other companies or people
          ("processors") to transfer the performance of certain tasks in our
          name. For this purpose it may be necessary for us to grant the
          processor access to personal data. Our processors are obliged to
          maintain confidentiality about the personal data transferred, and are
          not allowed to use the information for purposes other than those
          specified by us.{" "}
        </p>
        <p>
          Any transfer of personal data is done in accordance with the
          applicable data protection laws, and we ensure that suitable
          contractual, technical and organisational measures exist.
        </p>
        <hr />
        <h3>4. Third-party services or content on our website</h3>
        <p>
          On our website we offer third-party services and / or content. If you
          use these third-party services or if third-party content is shown,
          communication data is exchanged between you and the respective
          provider for technical reasons. We control neither the websites nor
          the data protection practices of the third parties, which manage these
          websites. This data privacy statement does not apply accordingly to
          the linked pages or services of third parties.
        </p>
        <p>
          The respective provider of the services or content can also collect
          further data and process it for other purposes of its own. To the best
          of our knowledge, we have configured the services and content of
          providers who process data for their own purposes, so that either
          communication is blocked for other purposes than communication or
          showing the services or content on our website, or personal data is
          only compiled if you have decided to use the respective service.
          However, as we have no control over the data that is collected and
          processed by third parties, we are not able to provide binding
          information about the scope and purpose of the processing of your data
          by the respective third-party provider.
        </p>
        <h5>a) Website links</h5>
        <p>
          For your information you can find links on our website which refer to
          third-party pages. As they are websites of other providers, we have no
          influence on their content; the respective provider is solely
          responsible for that. For the linked pages of third parties, this data
          privacy statement does not apply accordingly.
        </p>
        <h5>b) Tools</h5>
        <p>
          Our website uses the functions of Google Maps and YouTube to increase
          the functionality of our website.{" "}
        </p>
        <p>
          <b>Notes about Google Maps</b>
          <br />
          Our website uses the functions of the map service Google Maps. To use
          the functions of Google Maps it is necessary to save your IP address.
          This information can be transmitted to a Google server in the United
          States and stored there. We have no influence on this data
          transmitted.
        </p>
        <p>
          Google Maps is used in the interest of presenting our online offers in
          an appealing way, and making it easy to find us at the location
          provided on the website. This represents a justified interest.
        </p>
        <p>
          This function is provided by Google Inc., 1600 Amphitheatre Parkway,
          Mountain View, CA 94043, USA. More information about the handling of
          user data by Google can be found in the data privacy statement of
          Google.
        </p>
        <p>
          <b>Notes about YouTube</b>
          <br />
          Our website uses the functions of YouTube, which is operated by
          Google. If you visit a website of ours equipped with a YouTube
          plug-in, a connection is established to the servers of YouTube. This
          notifies the YouTube server of which of our pages you have visited. If
          you are logged into your YouTube account, you allow YouTube to
          directly allocate your surfing behaviour to your personal profile. You
          can prevent that by logging out of your YouTube account. We would like
          to point out that we have no knowledge of the content of the data
          transmitted, and its usage by YouTube.
        </p>
        <p>
          YouTube is used in the interest of presenting our online offers in an
          appealing way. This represents a justified interest.
        </p>
        <p>
          The plug-in is operated by YouTube LLC, 901 Cherry Ave., San Bruno, CA
          94066, USA. Further information about the handling of user data by
          YouTube can be found in the data privacy statement of YouTube.
        </p>
        <hr />
        <h3>5. The deletion of personal data</h3>
        <p>
          Provided we have not specified any special storage periods in this
          data privacy statement, the following general rules apply:
        </p>
        <p>
          In general, your data is deleted as soon as it is no longer necessary
          for the intended purpose, if you revoke your consent or if you revoke
          the usage based on a justified interest. The data is only saved after
          this period, if it is necessary due to a legal regulation which we are
          subject to (e.g. tax and commercial law provisions) or if the data is
          required for the establishment, assertion or defence against legal
          claims.
        </p>
        <hr />
        <h3>6. Safety & Security</h3>
        <p>
          All information which you send to us, is saved on servers within the
          European Union, the EEC and Switzerland. When saving this data, we
          place great emphasis on ensuring a suitable level of data protection
          in the respective country.
        </p>
        <p>
          We take suitable technical and organisational safety measures to
          protect your data from accidental or wilful manipulation, partial or
          full loss, destruction or unauthorised access by third parties. Our
          safety measures are continually improved and adjusted according to the
          latest technological developments.
        </p>
        <p>
          We would, however, like to point out that the transfer of data on the
          internet (e.g. in e-mail communication) may have safety flaws.
          Complete protection of data against third-party access is not
          possible.
        </p>
        <hr />
        <h3>7. Changes to the data privacy statement</h3>
        <p>
          This data privacy statement may be subject to amendments, for example
          due to changes in law or the method of processing data. We therefore
          request that you read this page on a regular basis.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
